import { Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '@app/services/authentication.service';
import { NeoTableService } from '../components/neo-table/neo-table.service';
import moment from 'moment';

@Pipe({
    name: 'neoLongDateAndTime',
    standalone: false
})
export class NeoLongDateAndTimePipe implements PipeTransform {
  constructor(private authService: AuthenticationService) { }
  /* This pipe converts the input date value according to the current Locale and Timezone.
     Input -> (date|string) -> "2022-11-02T09:22:08.098586"
     Output -> (string) -> "Wednesday, November 2, 2022 at 2:52 PM (AEDT)" */
  transform(value?: Date | string): string {
    if (!value) return '';
    const userTimezone = this.authService.getActiveUser()?.extensionTimezoneId || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const locale = navigator.language;
    const options: Intl.DateTimeFormatOptions | undefined = {
      year: 'numeric', month: 'long', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: true,
      weekday: 'long',
      timeZone: userTimezone,
    };
    const isoDateStr = NeoTableService.getISODatetimeString(value);
    return `${(new Date(isoDateStr)).toLocaleString(locale, options)} (${moment().tz(userTimezone).zoneAbbr()})`;
  }
}
